import { render, staticRenderFns } from "./trainingsHubCardStack.vue?vue&type=template&id=10612066&scoped=true"
import script from "./trainingsHubCardStack.vue?vue&type=script&lang=js"
export * from "./trainingsHubCardStack.vue?vue&type=script&lang=js"
import style0 from "./trainingsHubCardStack.vue?vue&type=style&index=0&id=10612066&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10612066",
  null
  
)

export default component.exports